<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    center
    title="历史导入查看"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <SiruiSearch
        ref="baseInfoFormRef"
        :query="query"
        :columns="formColumn"
        labelWidth="120px"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></SiruiSearch>
      <SiruiTable
        ref="siruiTable"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :showToolbar="false"
        :columns="tableColumnList"
      >
        <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </SiruiTable>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="cancelHandler" size="small">关闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import API from '@/api/property/leaseContract.js';
  export default {
    name: 'viewHistory',
    data() {
      return {
        query: {},
        dialogVisible: false,
        loading: false,
        tableData: [],
      };
    },
    computed: {
      formColumn() {
        return [
          {
            name: '合同编号',
            prop: 'contractNoLike',
            type: 'input',
          },
          {
            name: '客户名称',
            prop: 'customerNameLike',
            type: 'input',
          },
        ];
      },
      tableColumnList() {
        return [
          {
            field: 'contractNo',
            title: '合同编号',
            width: '150',
          },
          {
            field: 'customerName',
            title: '客户名称',
            width: '150',
          },
          {
            field: 'expenseTypeName',
            title: '减免类型',
            width: '150',
          },
          {
            field: 'reductionQuantity',
            title: '减免周期（月）',
            width: '150',
          },
          {
            field: 'reductionType',
            title: '减免方式',
            width: '150',
          },
          {
            // reductionAmount
            field: 'reductionRate',
            title: '减免比例/金额',
            width: '150',
          },
          {
            field: 'reductionStatus',
            title: '状态',
            width: '150',
          },
          {
            field: 'importDate',
            title: '导入时间',
            width: '150',
          },
        ];
      },
    },
    methods: {
      openModal(data = {}, fetchTableData = []) {
        this.query = {
          ...this.query,
          ...data,
        };
        console.log('queryGet', this.query);
        // 默认选中的
        this.lineDetailsList = fetchTableData;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getTableData();
        });
      },

      cancelHandler() {
        this.dialogVisible = false;
      },
      // 获取表格数据
      async getTableData() {
        this.loading = true;
        const postData = {
          ...this.query,
          businessCompanyNo: this.userInfo.companyCode,
          businessDepartmentCode: this.userInfo.departmentCode,
        };
        const { data } = await this.$axios.post(API.HISTORY_QUERY, postData);
        console.log(data);
        this.loading = false;
        this.tableData = Object.freeze(
          data.data.map((item) => {
            return {
              ...item,
              reductionRate: item.reductionRate ? item.reductionRate : item.reductionAmount,
            };
          })
        );
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        // this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        // this.$refs.siruiTable.setPageNum(1);
        // this.$refs.siruiTable.setPageSize(10);
        this.getTableData();
      },
    },
  };
</script>

<style></style>
